<template>
  <report-section title="睡眠时长概况" class="period-table-section">
    <template v-slot:content>
      <div>
        <div class="sleep-total-time-container">
          <p class="sleep-total-time">睡眠总时长TST:  {{reportDetailModel.totalHoursStr}}</p>
          <p class="sleep-total-time">监测时长: {{reportDetailModel.totalSleepTimeStr}}</p>
        </div>
        <table class="table">
          <thead>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">睡眠分期</td>
              <td class="table-row-item table-row-item-bold">监测时长</td>
              <td class="table-row-item table-row-item-bold">睡眠时间占比</td>
              <td class="table-row-item table-row-item-bold">睡眠期占比</td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">入睡后清醒(Wake)</td>
              <td class="table-row-item">
                {{ reportDetailModel.wakeMinutesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.wakeMinutesTestPercentStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.wakeMinutesSleepPercentStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">浅睡期(N1+N2)</td>
              <td class="table-row-item">
                {{ reportDetailModel.lightMinutesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.lightMinutesTestPercentStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.lightMinutesSleepPercentStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">深睡期(N3)</td>
              <td class="table-row-item">
                {{ reportDetailModel.deepMinutesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.deepMinutesTestPercentStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.deepMinutesSleepPercentStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">快速眼动期(REM)</td>
              <td class="table-row-item">
                {{ reportDetailModel.remMinutesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.remMinutesTestPercentStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.remMinutesSleepPercentStr }}
              </td>
            </tr>
          
           
          </thead>
        </table>
      </div>
    </template>
  </report-section>
</template>
          
          <script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  },
};
</script>
          
          <style lang="scss" scoped>
.period-table-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.sleep-total-time-container{
  .sleep-total-time {
    font-size: 16px;
    // font-weight: 500;
    color: black;
    margin-bottom: 10px;
  }
  display: flex;
  justify-content: space-between;
}

.table {
  border: 1px solid #707070;

  &-row {
    display: flex;
    justify-content: space-evenly;

    :nth-child(1) {
      width: 102px;
    }

    :nth-child(2) {
      width: 90px;
    }

    :nth-child(3) {
      width: 90px;
    }

    :nth-child(4) {
      width: 90px;
    }

    &-item {
      color: black;
      font-size: 16px;
      // font-weight: 400;
      border: 1px solid #707070;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      &-bold {
        // 移除默认的加粗样式，只在表头使用
      }
    }
  }
}

// 专门针对表头第一行进行加粗
.table .table-row:first-child .table-row-item-bold {
  font-weight: 600;
}

@media print {
  .period-table-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
}
</style>